import {
  green,
  red,
  grey,
} from '@material-ui/core/colors';

export default (theme) => ({
  statusContainer: {
    display: 'inline-block',
    overflow: 'auto',
    marginRight: 60,
  },
  statusColumn: {
    display: 'inline-block',
    verticalAlign: 'top',
    width: 340,
    marginRight: theme.spacing(2),
  },
  statusHeaderContainer: {
    display: 'inline-block',
    padding: theme.spacing(1),
    width: '100%',
  },
  badge: { margin: theme.spacing(2) },
  chip: {
    marginBottom: 10,
    marginRight: 5,
  },
  activeChip: {
    height: 20,
    margin: theme.spacing(1),
    backgroundColor: red[900],
    color: 'white',
  },
  completeChip: {
    height: 20,
    margin: theme.spacing(1),
    backgroundColor: green[900],
    color: 'white',
  },
  eventName: {
    margin: 0,
    fontWeight: 300,
    fontSize: '1.5em',
    lineHeight: 1.2,
  },
  status: {
    margin: 0,
    fontSize: '13px',
    fontWeight: 400,
    color: grey[500],
  },
  cardHeader: {
    alignItems: 'start',
    padding: 16,
  },
  isUpdatingProgress: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    margin: '1em',
  },
  card: {
    marginTop: theme.spacing(2),
    height: '100%',
    cursor: 'pointer',
    '&:hover': { background: grey[50] },
  },
  avatar: { marginRight: '.5em' },
  cardContent: { padding: '0 1em 1em 1em' },
  comment: { marginBottom: '.5em' },
  commentContainer: { marginBottom: '1.5em' },
  tagList: { marginTop: '1em' },
  newDivider: {
    backgroundColor: red[500],
    marginBottom: theme.spacing(2),
  },
  newText: {
    marginTop: theme.spacing(2),
    color: red[500],
  },
});
